export default {
	title: 'actions',
	icon: 'far fa-link',
	components: [{ title: 'actions', component: 'actions' }],
};
